import axios from 'axios'

class UploadFilesService {
  upload (file, sourceType, uploadParams, onUploadProgress) {
    const formData = new FormData()

    if (Array.isArray(file)) {
      // console.log(file.length)
      if (file.length === 1) {
        formData.append('import_file', file[0])
      } else {
        file.forEach((value, index) => {
          formData.append('import_file[]', value)
          // console.log(value)
        })
      }
    } else {
      // console.log('array false')
      formData.append('import_file', file)
      // console.log(file)
    }

    formData.append('sourceType', sourceType)
    formData.append('uploadParams', JSON.stringify(uploadParams))

    return axios.post('/api/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    })
  }

  getFiles () {
    return axios.get('/files')
  }
}

export default new UploadFilesService()
